import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "w100 pad40",
  style: {"height":"380px"}
}
const _hoisted_2 = { class: "title mc" }
const _hoisted_3 = {
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", {
  class: "fs12",
  style: {"margin-top":"10px"}
}, "既に日程を共有している方宛にリクエストのメールを送信します。", -1)
const _hoisted_6 = { class: "fl" }
const _hoisted_7 = {
  class: "rad4 fl",
  style: {"border":"1px solid #436f84","line-height":"26px"}
}
const _hoisted_8 = { style: {"margin":"8px"} }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "fs10" }
const _hoisted_11 = { class: "fw600" }
const _hoisted_12 = {
  key: 1,
  class: "fw600"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = { class: "fs12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_18 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_19 = {
  class: "posAb w50 centered",
  style: {"left":"0","bottom":"0"}
}
const _hoisted_20 = { class: "fs14 fw400" }
const _hoisted_21 = {
  class: "posAb w50 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_22 = { class: "fs14 whiteColor fw600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "RequestAdditionalPossibleDatesModal",
    "content-class": "modalContent shadowContent rad10 modalStandard posFi"
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(`schedule.request_other_dates`)), 1)
        ]),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t(`title.send_to`)) + ":  ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendMembers, (mem, memindex) => {
            return (_openBlock(), _createElementBlock("li", {
              key: memindex,
              class: _normalizeClass(_ctx.isSP ? `fs11` : `fs11 fl mr`),
              style: {"height":"30px","list-style":"none"}
            }, [
              _createElementVNode("span", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, [
                  (mem.is_company && mem.company_name)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, _toDisplayString(mem.company_name), 1),
                        _createElementVNode("span", _hoisted_11, _toDisplayString(mem.name), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(mem.name), 1))
                ])
              ])
            ], 2))
          }), 128))
        ]),
        _hoisted_13,
        _hoisted_14,
        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(`message.send_with_message`)), 1),
        _createVNode(_component_TextareaTag, {
          placeholder: "既に日程が埋まっていますため、別日程をお願いできますでしょうか。木曜日・金曜日の夕方以降でしたら、ご都合がつきやすいかと存じます。お手数ですが、よろしくお願いいたします。",
          style: {"height":"100px"},
          class: "fs14 roundForm mw100",
          value: _ctx.typedMessage,
          onInputValue: _ctx.inputMessage
        }, null, 8, ["value", "onInputValue"]),
        _hoisted_16,
        _hoisted_17
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("section", {
            class: "with_white_bg dgrey fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.cancelInput && _ctx.cancelInput(...args)))
          }, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t(`title.close`)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("section", {
            class: "w100 pinkBg fs16 pointer centered",
            style: {"line-height":"50px","height":"50px"},
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)))
          }, [
            _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t(`schedule.request`)), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}